import { render } from "./DashboardContent.vue?vue&type=template&id=59abd2ec"
import script from "./DashboardContent.vue?vue&type=script&lang=js"
export * from "./DashboardContent.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__